import React, { Component } from 'react';

import FindJobView from './FindJobView';
import { url } from '../../Server/url/GlobalUrl';
import moment from 'moment';

class FindJobComponent extends Component {
  state = {
    jobs: [],
    carer_type: [],
    qualification: [],
    contract_type: [],
    city_checked: '',
    carertype_checked: '',
    qualification_checked: [],
    contract_type_checked: '',
    qualification_data: [],
    count: '',
    wishlist_data: [],
    card: true,
    list_active: '',
    card_active: 'active',
    modal_show: false,
    search_input_postcode: '',
    apply_modal_show: false,
    apply_job_check: false,
    authResponse: '',
    expand: 'none',
    expand_id: '',
    change_place: false,
    length: 0,
    applied_job_id: '',
    applied_shift_id: [],
    shift_select_timing: [],
    today_date: moment(new Date()).format('YYYY-MM-DD'),
    filter_contract_type: [],
    filter_carer_type: [],
  };
  applyHideCustomModal = () => {
    this.setState({ apply_modal_show: false });
  };

  applyShowCustomModal = (id) => {
    this.setState({ apply_job_check: true });
    console.log('id', id);
    if (localStorage.getItem('token')) {
      let auth = localStorage.getItem('token');
      fetch(url + '/jobs/job-shifts/?job_id=' + id, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + auth,
        },
      })
        .then((res) => res.json())
        .then(
          (result) => {
            console.log('result-showCustomModal', result);
            this.setState({ shift_select_timing: result, applied_job_id: id });
            this.setState({ apply_modal_show: true });
          },
          (error) => {
            console.log('error', error);
          }
        );
    } else {
      window.location.replace('/login');
    }
  };

  declineJobModal = (id) => {
    this.setState({ jobs: this.state.jobs.filter((each) => each.id !== id) });
  };

  applyShowCustomModalFavorite = (id) => {
    this.setState({ apply_job_check: false });
    console.log('id', id);
    if (localStorage.getItem('token')) {
      let auth = localStorage.getItem('token');
      fetch(url + '/jobs/job-shiftswl/?job_id=' + id, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + auth,
        },
      })
        .then((res) => res.json())
        .then(
          (result) => {
            console.log('result', result);

            this.setState({ shift_select_timing: result, applied_job_id: id });
            this.setState({ apply_modal_show: true });
          },
          (error) => {
            console.log('error', error);
          }
        );
    } else {
      window.location.replace('/login');
    }
  };

  hideCustomModal = () => {
    this.setState({ modal_show: false });
    if (this.state.change_place) {
      window.location.replace('/registration/submit-cv/#edit');
    }
  };

  showCustomModal = () => {
    this.setState({ modal_show: true });
  };

  handelFormat = () => {
    console.log('yes i am in');
    console.log(this.state.list_active, this.state.card_active);
    if (this.state.card) {
      this.setState({
        card: false,
        list_active: 'active',
        card_active: '',
      });
    } else {
      this.setState({
        card: true,
        card_active: 'active',
        list_active: '',
      });
    }
  };

  handelSearch = () => {
    console.log(this.state.search_input_postcode);
    let auth = localStorage.getItem('token');
    fetch(
      url + '/jobs/job-post/?postcode=' + this.state.search_input_postcode,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + auth,
        },
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('result_btao', result);
          if (
            result.detail === 'Given token not valid for any token type' ||
            result.detail === 'User not found'
          ) {
            this.setState({ jobs: [] });
            localStorage.removeItem('token');
            window.location.replace('/login');
          } else {
            this.setState({ jobs: result });
            this.setState({ length: result.length });
            console.log('buddha', this.state.jobs);
          }
        },
        (error) => {
          console.log('error', error);
        }
      );
  };

  handelShift = (id, checked) => {
    console.log('shift  id', id, checked);
    if (id === 'all') {
      if (checked) {
        var i;
        for (i = 0; i < this.state.shift_select_timing.length; i++) {
          this.state.applied_shift_id.push(
            this.state.shift_select_timing[i].shift_id
          );
          this.setState({ applied_shift_id: this.state.applied_shift_id });
        }
        console.log('this.state.applied_shift_id', this.state.applied_shift_id);
      } else {
        this.state.applied_shift_id.splice(
          0,
          this.state.applied_shift_id.length
        );
        this.setState({ applied_shift_id: this.state.applied_shift_id });
        console.log('this.state.applied_shift_id', this.state.applied_shift_id);
      }
    } else {
      if (
        this.state.applied_shift_id.length ===
        this.state.shift_select_timing.length
      ) {
        return;
      }
      if (checked) {
        this.state.applied_shift_id.push(id);
        this.setState({ applied_shift_id: this.state.applied_shift_id });
      } else {
        var index = this.state.applied_shift_id
          .map((x) => {
            return x.Id;
          })
          .indexOf(id);
        console.log('id', id);
        this.state.applied_shift_id.splice(index, 1);
        this.setState({ applied_shift_id: this.state.applied_shift_id });
      }
    }
    console.log('this.state.applied_shift_id', this.state.applied_shift_id);
  };

  // addToFavourites = (id) =>{
  //     console.log(id);
  //     let auth = localStorage.getItem("token");
  //     // let user = localStorage.getItem("cv-id");

  //     if(auth) {
  //         fetch(url + "/jobs/wishlist/" ,{
  //             method:"POST",
  //             headers: {
  //                 'Accept': "application/json",
  //                 'Content-Type': "application/json",
  //                 'Authorization': 'Bearer ' + auth,

  //             },
  //             body:JSON.stringify({"job_post": id})
  //             })
  //             .then((response) => {
  //                 // console.log("Response", response.json())
  //                 // return response.json()

  //                 // console.log(this.state.data);
  //                 if(response['status'] === 201 || response['status'] === 200){
  //                     this.showCustomModal()
  //                     this.setState({authResponse:"Added to the favourites"});
  //                     this.get_wishlist_data();
  //                 }
  //             })
  //                 // .then((data) =>{
  //                 //     this.showCustomModal()
  //                 //     this.setState({authResponse:"Added to the favourites"});
  //                 //     console.log(data);
  //                 // })

  //                   .catch((err) => {
  //                      this.showCustomModal()
  //                     this.setState({authResponse:"Error While Adding to favourites"});
  //                     console.log("ERROR",err.body);
  //                 })
  //     } else {
  //         window.location.replace('/login')
  //     }

  //      }
  // console.log("DD")

  //   removeFromFavourites = (job_id) =>{
  //     const data = this.state.wishlist_data.filter((each) => each.job_post == job_id);
  //     console.log(data);
  //     const id = data[0].id
  //     console.log(id);
  //     let auth = localStorage.getItem("token");
  //     // let user = localStorage.getItem("cv-id");
  //     fetch(url + "/jobs/wishlist/"+id+"/",{
  //     method:"DELETE",
  //     headers: {
  //         'Accept': "application/json",
  //         'Content-Type': "application/json",
  //         'Authorization': 'Bearer ' + auth,

  //     },
  //     })
  //     .then((response) => {
  //         // console.log("Response", response.json())
  //         console.log(response);
  //         if(response['status'] === 204 || response['status'] === 200){
  //             this.showCustomModal()
  //             this.setState({authResponse:"Removed from  the favourites"});
  //             this.get_wishlist_data();
  //         }
  //     })
  //         // .then((data) =>{
  //         //     this.showCustomModal()
  //         //     this.setState({authResponse:"Removed from  the favourites"});
  //         //     console.log(data);
  //         // })

  //           .catch((err) => {
  //              this.showCustomModal()
  //             this.setState({authResponse:"Error While Removing to favourites"});
  //             console.log("ERROR",err);
  //         })
  //      }

  handelcompression = (id) => {
    console.log('id', id);
    if (this.state.expand_id === id) {
      if (this.state.expand == 'block') {
        this.setState({ expand: 'none' });
        this.setState({ expand_id: id });
      } else {
        this.setState({ expand: 'block' });
      }
    } else {
      this.setState({ expand: 'block' });
      this.setState({ expand_id: id });
    }
  };

  return_string_data = (ids) => {
    var result = [];
    for (var each of this.state.qualification) {
      for (var id of ids) {
        if (each.id == id) {
          // console.log(id,each.id);
          if (!result.includes(each.type)) {
            result.push(each.type);
          }
        }
      }
    }
    return result.join(',');
  };

  applyfavorite = async () => {
    let id = this.state.applied_job_id;
    this.applyHideCustomModal();
    console.log('shift id', this.state.applied_shift_id);
    console.log('job id', this.state.applied_job_id);
    if (localStorage.getItem('token')) {
      var i;
      for (i = 0; i < this.state.applied_shift_id.length; i++) {
        let data = {
          job_post: this.state.applied_job_id,
          shift: this.state.applied_shift_id[i],
        };
        console.log('data', data);
        let auth = localStorage.getItem('token');
        await fetch(url + '/jobs/wishlist/', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + auth,
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            console.log('response', response);
            if (response['status'] === 201 || response['status'] === 200) {
              this.showCustomModal();
              this.setState({
                authResponse: 'Job Is Added to the favourites successfully ',
              });
              return response.json();
            } else if (
              response['status'] === 400 ||
              response['status'] === 401
            ) {
              this.showCustomModal();
              this.setState({
                authResponse: 'Some thing went wrong please try again ',
              });
            } else if (response['status'] == 406) {
              this.showCustomModal();
            }
            return response.json();
          })
          .then((result) => {
            if (result.error) {
              this.setState({ authResponse: result.error });
            }
            console.log('result', result);
          });
      }
      this.state.applied_shift_id.splice(0, this.state.applied_shift_id.length);
      this.setState({ applied_shift_id: this.state.applied_shift_id });
    } else {
      window.location.replace('/login');
    }
  };

  applyjob = async () => {
    let id = this.state.applied_job_id;
    this.applyHideCustomModal();
    console.log('shift id', this.state.applied_shift_id);
    console.log('job id', this.state.applied_job_id);
    if (localStorage.getItem('token')) {
      var i;
      for (i = 0; i < this.state.applied_shift_id.length; i++) {
        let data = {
          job: this.state.applied_job_id,
          shift: this.state.applied_shift_id[i],
        };
        let auth = localStorage.getItem('token');
        await fetch(url + '/jobs/user-applied-jobs/', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + auth,
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            console.log('response', response);
            if (response['status'] === 201 || response['status'] === 200) {
              this.showCustomModal();
              this.setState({
                authResponse: 'You Have applied to job successfully ',
              });
              return response.json();
            } else if (
              response['status'] === 400 ||
              response['status'] === 401
            ) {
              this.showCustomModal();
              this.setState({
                authResponse: 'Some thing went wrong please try again ',
              });
            } else if (response['status'] === 406) {
              this.showCustomModal();
              // this.setState({authResponse:"Already Applied !"})
            }
            return response.json();
          })
          .then((result) => {
            console.log('result', result);
            if (result.error) {
              this.setState({ authResponse: result.error });
              if (result.error === 'You are not assigned a role of candidate') {
                this.setState({ change_place: true });
              }
            }
            console.log(result.error);
          });
      }
      this.state.applied_shift_id.splice(0, this.state.applied_shift_id.length);
      this.setState({ applied_shift_id: this.state.applied_shift_id });
    } else {
      window.location.replace('/login');
    }
  };

  handelSummit = (identifier, data, status) => {
    console.log('identifier', identifier, status, data);
    if (identifier === 'contract_type') {
      if (status === true) {
        if (this.state.contract_type_checked === data) {
          var a = document.getElementsByClassName('contract-input');
          for (var i = 0; i < a.length; i++) {
            a[i].checked = false;
          }
          this.setState({ contract_type_checked: '' });
        } else {
          console.log('idesadsdsifier', identifier, status);
          this.setState({ contract_type_checked: data });
        }
      } else if (status === false) {
        console.log('dalsdkasd');
        this.setState({ contract_type_checked: '' });
        let array = [...this.state.filter_contract_type];

        let index = array.indexOf(data);

        if (index !== -1) {
          array.splice(index, 1);
          this.setState({ filter_contract_type: array });
        }

        console.log(
          'FILTER-DATA-AFTER-REMOVE ',
          this.state.filter_contract_type
        );
      }
    } else if (identifier === 'qualification') {
      if (status === true) {
        console.log('data', data);
        if (this.state.qualification_checked === data) {
          var a = document.getElementsByClassName('qualification_type-input');
          for (var i = 0; i < a.length; i++) {
            a[i].checked = false;
          }
          this.setState({ qualification_checked: '' });
        } else {
          this.setState({ qualification_checked: data });
        }
      }
      if (status === false) {
        this.state.qualification_checked.push(data);
        this.setState({
          qualification_checked: this.state.qualification_checked,
        });
      }

      console.log('data', this.state.qualification_checked);
    } else if (identifier === 'carer_type') {
      if (status === true) {
        if (this.state.carertype_checked === data) {
          var a = document.getElementsByClassName('carer_type-input');
          for (var i = 0; i < a.length; i++) {
            a[i].checked = false;
          }
          this.setState({ carertype_checked: '' });
        } else {
          this.setState({ carertype_checked: data });
        }
      } else {
        this.setState({ carertype_checked: '' });
        let arr = [...this.state.filter_carer_type];
        let index = arr.indexOf(data);

        if (index !== -1) {
          arr.splice(index, 1);
          this.setState({ filter_carer_type: arr });
        }

        console.log('REMOVE-CARER-TYPE', this.state.filter_carer_type);
      }
    } else if (identifier === 'city') {
      if (status === true) {
        this.setState({ city_checked: data });
      } else {
        this.setState({ city_checked: '' });
      }
    } else if (identifier == 'search_input_postcode') {
      console.log('Value', data);
      this.setState({ search_input_postcode: data });
    }
    console.log('data', data, this.state.carertype_checked);
    let data_refresh = { refresh: localStorage.getItem('refresh') };
    fetch(url + '/api/token/refresh/', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data_refresh),
    })
      .then((response) => {
        if (response['status'] === 201 || response['status'] === 200) {
          return response.json();
        } else if (response['status'] === 401 || response['status'] === 400) {
          //                this.showCustomModal()
          //                this.setState({authResponse:'Some Thing went wrong'})
          localStorage.removeItem('refresh');
          localStorage.removeItem('token');
          localStorage.removeItem('is_applicant');
          localStorage.removeItem('is_admin');
          localStorage.removeItem('is_candidate');
          localStorage.removeItem('is_pre_screen_applicant');
        }
      })
      .then((result) => {
        if (result) {
          console.log('result.access', result.access);
          localStorage.setItem('token', result.access);
          console.log(
            'this.state.carertype_checked',
            this.state.carertype_checked
          );
          console.log(
            'this.state.contract_type_checked',
            this.state.contract_type_checked
          );
          let auth = localStorage.getItem('token');
          if (this.state.qualification_checked.length > 0) {
            var check = JSON.stringify(this.state.qualification_checked);
          } else {
            var check = '';
          }
          console.log(
            'see this',
            url +
              '/jobs/job-post/?booking_active=true&city=' +
              this.state.city_checked +
              '&carertype=' +
              this.state.carertype_checked +
              '&qualification=' +
              check +
              '&contract_type=' +
              this.state.contract_type_checked
          );
          fetch(
            url +
              '/jobs/job-post/?booking_active=true&city=' +
              this.state.city_checked +
              '&carertype=' +
              this.state.carertype_checked +
              '&contract_type=' +
              this.state.contract_type_checked,
            {
              method: 'GET',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
            }
          )
            .then((res) => res.json())
            .then(
              (result) => {
                console.log('result', result);
                if (
                  result.detail === 'Given token not valid for any token type'
                ) {
                  console.log('result', result);
                  this.setState({ jobs: [] });
                  localStorage.removeItem('token');
                } else {
                  if (result) {
                    var i;
                    for (i of result) {
                      if (
                        i.start_date_arrival_time ||
                        i.start_date_departure_time ||
                        i.end_date_arrival_time ||
                        i.end_date_departure_time
                      ) {
                        if (i.start_date_arrival_time) {
                          var start_date_arrival_time = this.tConvert(
                            i.start_date_arrival_time
                          );
                          i['start_date_arrival_time'] =
                            start_date_arrival_time;
                        }
                        if (i.start_date_departure_time) {
                          var start_date_departure_time = this.tConvert(
                            i.start_date_departure_time
                          );
                          i['start_date_departure_time'] =
                            start_date_departure_time;
                        }
                        if (i.end_date_arrival_time) {
                          var end_date_arrival_time = this.tConvert(
                            i.end_date_arrival_time
                          );
                          i['end_date_arrival_time'] = end_date_arrival_time;
                        }
                        if (i.end_date_departure_time) {
                          var end_date_departure_time = this.tConvert(
                            i.end_date_departure_time
                          );
                          i['end_date_departure_time'] =
                            end_date_departure_time;
                        }
                      }
                      if (i.start_date) {
                        var day = moment(i.start_date).format('dddd DD/MM');
                        i['start_shift'] =
                          day +
                          ' from ' +
                          start_date_arrival_time +
                          ' to ' +
                          start_date_departure_time;
                      }
                      if (i.end_date) {
                        var day = moment(i.end_date).format('dddd DD/MM');
                        i['end_shift'] =
                          day +
                          ' from ' +
                          end_date_arrival_time +
                          ' to ' +
                          end_date_departure_time;
                      }
                      if (i.qualification) {
                        var k = '';
                        var j;
                        var r = '';

                        i['qualification'] = i.qualification.join(',');
                      }
                      if (i.shifts.length > 0) {
                        var j;
                        for (j of i.shifts) {
                          console.log('shifts.length', j);
                          var start_string =
                            j.start_quantity +
                            ' Nurses' +
                            ' ' +
                            j.start_repeate +
                            ' begins ' +
                            j.start_date +
                            ' from ' +
                            j.start_date_arrival_time +
                            ' to ' +
                            j.start_date_departure_time;
                          var end_string =
                            j.end_quantity +
                            ' Nurses' +
                            ' ' +
                            j.end_repeate +
                            ' begins ' +
                            j.end_date +
                            ' from ' +
                            j.end_date_arrival_time +
                            ' to ' +
                            j.end_date_departure_time;
                          j['start_string'] = start_string;
                          j['end_string'] = end_string;
                        }
                      }
                    }
                    this.setState({ jobs: result });
                    this.setState({ length: result.length });
                    console.log('buddha', this.state.jobs);
                  }
                }
              },
              (error) => {
                console.log('error', error);
              }
            );
        }
      });
  };

  // get_wishlist_data = () => {
  //    let auth = localStorage.getItem("token");
  //     let user = localStorage.getItem("cv-id");
  //     fetch(url + "/jobs/wishlist/?user="+user ,{
  //     method:"GET",
  //     headers: {
  //         'Accept': "application/json",
  //         'Content-Type': "application/json",
  //         'Authorization': 'Bearer ' + auth,

  //     },
  //     })
  //     .then((response) => {
  //         if(response['status'] === 201 || response['status'] === 200){
  //             return response.json()
  //         }
  //         else return []
  //     })
  //         .then((data) =>{
  //             // this.showCustomModal()
  //             // this.setState({authResponse:"Added to the favourites"});
  //             console.log("DATA");
  //             this.setState({wishlist_data: data})
  //             console.log(data)

  //         })

  //           .catch((err) => {
  //              this.showCustomModal()
  //             this.setState({authResponse:"Error While Adding to favourites"});
  //             console.log("ERROR",err.body);
  //         })

  // }
  componentDidMount() {
    fetch(url + '/jobs/counts/', {
      method: 'GET',
    })
      .then((res) => res.json())
      .then(
        (result_count) => {
          this.setState({ count: result_count });
          console.log('count1', result_count);
          fetch(url + '/jobs/carer-type/', {
            method: 'GET',
          })
            .then((res) => res.json())
            .then(
              (result) => {
                if (result) {
                  console.log('count', result);
                  var i;
                  for (i of result) {
                    var b = result_count[i.type];
                    if (b) {
                      i['count'] = b;
                      console.log('hello', i);
                    }
                  }
                }
                this.setState({ carer_type: result });
                console.log('result0123', result);
              },
              (error) => {
                console.log('error', error);
              }
            );
          fetch(url + '/jobs/qualification/', {
            method: 'GET',
          })
            .then((res) => res.json())
            .then(
              (result) => {
                if (result) {
                  var i;
                  for (i of result) {
                    var b = result_count[i.type];
                    if (b) {
                      i['count'] = b;
                      console.log('hello', i);
                    }
                  }
                }
                this.setState({ qualification: result });
                console.log('qualification', result);
              },
              (error) => {
                console.log('error', error);
              }
            );
          fetch(url + '/jobs/contract-type/', {
            method: 'GET',
          })
            .then((res) => res.json())
            .then(
              (result) => {
                console.log('result', result);
                if (result) {
                  var i;
                  for (i of result) {
                    var b = result_count[i.type];

                    console.log("i['count']", i['count']);
                    i['count'] = b;
                    console.log('hello', i);
                  }
                }
                this.setState({ contract_type: result });
                console.log('contract_type', result);
              },
              (error) => {
                console.log('error', error);
              }
            );
        },
        (error) => {
          console.log('error', error);
        }
      );

    let data_refresh = { refresh: localStorage.getItem('refresh') };

    fetch(url + '/api/token/refresh/', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data_refresh),
    })
      .then((response) => {
        if (response['status'] === 201 || response['status'] === 200) {
          return response.json();
        } else if (response['status'] === 401 || response['status'] === 400) {
          //                this.showCustomModal()
          //                this.setState({authResponse:'Some Thing went wrong'})
          localStorage.removeItem('refresh');
          localStorage.removeItem('token');
          localStorage.removeItem('is_applicant');
          localStorage.removeItem('is_admin');
          localStorage.removeItem('is_candidate');
          localStorage.removeItem('is_pre_screen_applicant');
        }
      })
      .then((result) => {
        if (result) {
          console.log('result.access', result.access);
          localStorage.setItem('token', result.access);
        }
      });

    let auth = localStorage.getItem('token');
    fetch(url + '/jobs/job-post/?booking_active=true', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + auth,
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('result_btao', result);
          if (
            result.detail === 'Given token not valid for any token type' ||
            result.detail === 'User not found'
          ) {
            this.setState({ jobs: [] });
            localStorage.removeItem('token');
            window.location.replace('/login');
          } else {
            if (result.length > 0) {
              this.setState({ length: result.length });
              var i;
              for (i of result) {
                if (
                  i.start_date_arrival_time ||
                  i.start_date_departure_time ||
                  i.end_date_arrival_time ||
                  i.end_date_departure_time
                ) {
                  if (i.start_date_arrival_time) {
                    var start_date_arrival_time = this.tConvert(
                      i.start_date_arrival_time
                    );
                    i['start_date_arrival_time'] = start_date_arrival_time;
                  }
                  if (i.start_date_departure_time) {
                    var start_date_departure_time = this.tConvert(
                      i.start_date_departure_time
                    );
                    i['start_date_departure_time'] = start_date_departure_time;
                  }
                  if (i.end_date_arrival_time) {
                    var end_date_arrival_time = this.tConvert(
                      i.end_date_arrival_time
                    );
                    i['end_date_arrival_time'] = end_date_arrival_time;
                  }
                  if (i.end_date_departure_time) {
                    var end_date_departure_time = this.tConvert(
                      i.end_date_departure_time
                    );
                    i['end_date_departure_time'] = end_date_departure_time;
                  }
                }
                if (i.start_date) {
                  var day = moment(i.start_date).format('dddd DD/MM');
                  i['start_shift'] =
                    day +
                    ' from ' +
                    start_date_arrival_time +
                    ' to ' +
                    start_date_departure_time;
                }
                if (i.end_date) {
                  var day = moment(i.end_date).format('dddd DD/MM');
                  i['end_shift'] =
                    day +
                    ' from ' +
                    end_date_arrival_time +
                    ' to ' +
                    end_date_departure_time;
                }
                i['qualification'] = i.qualification.join(',');

                console.log('i.shifts', i.shifts);
                if (i.shifts.length > 0) {
                  var j;
                  for (j of i.shifts) {
                    console.log('shifts.length', j);
                    var start_string =
                      j.start_quantity +
                      ' Nurses' +
                      ' ' +
                      j.start_repeate +
                      ' begins ' +
                      j.start_date +
                      ' from ' +
                      j.start_date_arrival_time +
                      ' to ' +
                      j.start_date_departure_time;
                    var end_string =
                      j.end_quantity +
                      ' Nurses' +
                      ' ' +
                      j.end_repeate +
                      ' begins ' +
                      j.end_date +
                      ' from ' +
                      j.end_date_arrival_time +
                      ' to ' +
                      j.end_date_departure_time;
                    j['start_string'] = start_string;
                    j['end_string'] = end_string;
                  }
                }
              }
              this.setState({ jobs: result });
              console.log('buddha', this.state.jobs);
            }
          }
        },
        (error) => {
          console.log('error', error);
        }
      );

    // let auth = localStorage.getItem("token");
    // this.get_wishlist_data();
  }
  tConvert(time) {
    // Check correct time format and split into components
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      console.log('helllio', time);
      time.splice(-1, 1);
    }
    return time.join(''); // return adjusted time or original string
  }

  render() {
    return (
      <FindJobView
        jobs={this.state.jobs}
        carer_type={this.state.carer_type}
        qualification={this.state.qualification}
        contract_type={this.state.contract_type}
        today_date={this.state.today_date}
        handelSummit={this.handelSummit}
        applyjob={this.applyjob}
        authResponse={this.state.authResponse}
        modal_show={this.state.modal_show}
        hideCustomModal={this.hideCustomModal}
        showCustomModal={this.showCustomModal}
        apply_modal_show={this.state.apply_modal_show}
        applyHideCustomModal={this.applyHideCustomModal}
        applyShowCustomModal={this.applyShowCustomModal}
        handelcompression={this.handelcompression}
        expand={this.state.expand}
        return_string_data={this.return_string_data}
        expand_id={this.state.expand_id}
        length={this.state.length}
        handelFormat={this.handelFormat}
        list_active={this.state.list_active}
        card_active={this.state.list_active}
        card={this.state.card}
        declineJobModal={this.declineJobModal}
        handelSearch={this.handelSearch}
        addToFavourites={this.addToFavourites}
        wishlist_data={this.state.wishlist_data}
        removeFromFavourites={this.removeFromFavourites}
        shift_select_timing={this.state.shift_select_timing}
        applied_shift_id={this.state.applied_shift_id}
        handelShift={this.handelShift}
        applyShowCustomModalFavorite={this.applyShowCustomModalFavorite}
        apply_job_check={this.state.apply_job_check}
        applyfavorite={this.applyfavorite}
        filter_contract_type={this.state.filter_contract_type}
        filter_carer_type={this.state.filter_carer_type}
      />
    );
  }
}

export default FindJobComponent;
